import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-beaf8dda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "UploadContractAdd" }
const _hoisted_2 = { class: "form-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank spacing" }, "施工申请情况", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-color" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "付款约定")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "其他说明")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "图片")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, [
    /*#__PURE__*/_createTextVNode("合同附件 "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#999999","font-size":"12px"} }, "（可上传图片、word、excel、pdf）")
  ])
], -1))
const _hoisted_12 = {
  key: 0,
  class: "uploader"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_14 = {
  key: 1,
  class: "uploader"
}
const _hoisted_15 = { class: "self_flex_row self_justify_between self_align_center" }
const _hoisted_16 = { class: "self_flex_row self_align_center" }
const _hoisted_17 = { class: "image" }
const _hoisted_18 = { class: "file_type" }
const _hoisted_19 = { class: "type-rd" }
const _hoisted_20 = { style: {"font-size":"10px"} }
const _hoisted_21 = {
  class: "",
  style: {"color":"#000000"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_24 = { class: "submit-btn" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { onMounted, ref, watch, reactive } from 'vue'
import { useRouter } from 'vue-router'
import SimpImageUpload from '@/components/SimpImageUpload.vue'
import { saveProject, contractSave } from '@/apis/uploadContract'
import { uploadFileItem } from '@/apis/base'
import { Toast } from 'vant'
import dayjs from 'dayjs'
import { ApproveConfig, CarboncopyConfig } from '@/apis/public/oauth'
import { uploadFile1 } from '@/apis/public/file'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const conterData = ref({} as saveProject)
const currentDate = ref(new Date(dayjs().format('YYYY-MM-DD')))

const showFile = ref(false)
const state = reactive({
  suffixName: ''
})

const formatDate = date => {
  return `${dayjs(date).format('YYYY-MM-DD')}`
}

// showTimePicker1 showTimePicker2 时间显示组件
const showTimePicker1 = ref(false)
const onTimeConfirm1 = data => {
  conterData.value.delivery_date = formatDate(data)
  showTimePicker1.value = false
}
const showTimePicker2 = ref(false)
const onTimeConfirm2 = data => {
  conterData.value.finish_date = formatDate(data)
  showTimePicker2.value = false
}

//上传文件
const afterRead = (file: any) => {
  Toast.loading({
    message: '上传中...',
    forbidClick: true,
    duration: 0
  })
  console.log('afterRead.file ===>', file)
  state.suffixName = file.file.name.substring(file.file.name.lastIndexOf('.') + 1)
  console.log('====substring>', state.suffixName)
  conterData.value.name = file.file.name
  conterData.value.size = sizeTostr(file.file.size)
  // 循环上传
  file.status = 'uploading'
  file.message = '上传中...'

  const param = new FormData()
  param.append('uploadFile', file.file, file.file.name)

  uploadFile1(param).then((res: any) => {
    if (res.code == 200) {
      conterData.value.attachment = res.data.url
      file.status = 'done'
      file.message = '上传成功'
      Toast.clear()
      showFile.value = true
    } else {
      file.status = 'failed'
      file.message = '上传失败'
    }
  })
}

const to_clear = () => {
  showFile.value = false
  conterData.value.attachment = ''
}

const sizeTostr = size => {
  var data = ''
  if (size < 0.1 * 1024) {
    //如果小于0.1KB转化成B
    data = size.toFixed(2) + 'B'
  } else if (size < 0.1 * 1024 * 1024) {
    //如果小于0.1MB转化成KB
    data = (size / 1024).toFixed(2) + 'KB'
  } else if (size < 0.1 * 1024 * 1024 * 1024) {
    //如果小于0.1GB转化成MB
    data = (size / (1024 * 1024)).toFixed(2) + 'MB'
  } else {
    //其他转化成GB
    data = (size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }
  var sizestr = data + ''
  var len = sizestr.indexOf('\.')
  var dec = sizestr.substr(len + 1, 2)
  if (dec == '00') {
    //当小数点后为00时 去掉小数部分
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
  }
  return sizestr
}

const onSubmit = async () => {
  console.log(conterData.value)
  const res = await contractSave(conterData.value)
  if (res.code == 200) {
    console.log(res.data)
    Toast.success({
      message: res.msg,
      duration: 500,
      onClose: () => {
        router.back()
      }
    })
  } else {
    Toast(res.msg)
  }
}

const fileList = ref<Array<uploadFileItem>>([])
watch(fileList, (newVal, oldVal) => {
  console.log('ticket add fileList ===>', newVal)
  // data.saveData.upload_file_list = newVal
  conterData.value.pics = newVal
})
const StaffInfo = ref({
  currentTime: '--', // 当前时间
  company_froms: {
    cf_name: '--'
  },
  name: '--'
})

const review_carbon = ref({
  review: [],
  carbon: []
})

const get_approve_config = async () => {
  let typeId = {
    type: 4
  }
  const res = await ApproveConfig(typeId)
  const res1 = await CarboncopyConfig(typeId)
  if (res.code === 200) {
    if (res.data) {
      res.data.forEach(e => {
        review_carbon.value.review.push(e.staff)
      })
    }
  }
  if (res1.code === 200) {
    if (res1.data) {
      res1.data.forEach(e => {
        review_carbon.value.carbon.push(e.staff)
      })
    }
  }
}

onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  StaffInfo.value.currentTime = dayjs().format('YYYY-MM-DD HH:mm')
  conterData.value.project_id = Number(router.currentRoute.value.query.project_id)
  conterData.value.project_name = router.currentRoute.value.query.project_name.toString()
  get_approve_config()
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_common_info = _resolveComponent("common-info")!
  const _component_review_people = _resolveComponent("review-people")!
  const _component_bottom_button = _resolveComponent("bottom-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_form, { onSubmit: onSubmit }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_cell_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_cell, {
                    title: "项目名称",
                    value: conterData.value.project_name
                  }, null, 8, ["value"]),
                  _hoisted_3,
                  _createVNode(_component_van_field, {
                    modelValue: conterData.value.company,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((conterData.value.company) = $event)),
                    label: "签约单位",
                    "input-align": "right",
                    name: "text",
                    placeholder: "请输入",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    modelValue: conterData.value.money,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((conterData.value.money) = $event)),
                    "label-width": "120",
                    label: "合同金额（元）",
                    "input-align": "right",
                    name: "text",
                    placeholder: "请输入",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    modelValue: conterData.value.tax,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((conterData.value.tax) = $event)),
                    label: "税点(%)",
                    "input-align": "right",
                    name: "text",
                    placeholder: "请输入",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    modelValue: conterData.value.delivery_date,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((conterData.value.delivery_date) = $event)),
                    label: "交货时间",
                    "input-align": "right",
                    "is-link": "",
                    readonly: "",
                    name: "picker",
                    placeholder: "请选择",
                    required: "",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showTimePicker1.value = true))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    modelValue: conterData.value.finish_date,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((conterData.value.finish_date) = $event)),
                    label: "完工时间",
                    "input-align": "right",
                    "is-link": "",
                    readonly: "",
                    name: "picker",
                    placeholder: "请选择",
                    required: "",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (showTimePicker2.value = true))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    modelValue: conterData.value.shelf_life,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((conterData.value.shelf_life) = $event)),
                    label: "质保期",
                    "input-align": "right",
                    name: "text",
                    placeholder: "请输入",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    modelValue: conterData.value.shelf_life_money,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((conterData.value.shelf_life_money) = $event)),
                    "label-width": "100",
                    label: "质保金（元）",
                    "input-align": "right",
                    name: "text",
                    placeholder: "请输入",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_4,
                  _createVNode(_component_van_cell, null, {
                    title: _withCtx(() => [
                      _hoisted_5
                    ]),
                    label: _withCtx(() => [
                      _createVNode(_component_van_field, {
                        modelValue: conterData.value.payment_promise,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((conterData.value.payment_promise) = $event)),
                        rows: "2",
                        autosize: "",
                        type: "textarea",
                        placeholder: "请输入约定",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _hoisted_6,
                  _createVNode(_component_van_cell, null, {
                    title: _withCtx(() => [
                      _hoisted_7
                    ]),
                    label: _withCtx(() => [
                      _createVNode(_component_van_field, {
                        modelValue: conterData.value.other_promise,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((conterData.value.other_promise) = $event)),
                        rows: "2",
                        autosize: "",
                        type: "textarea",
                        placeholder: "请输入说明",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _hoisted_8,
                  _createVNode(_component_van_cell, null, {
                    title: _withCtx(() => [
                      _hoisted_9
                    ]),
                    label: _withCtx(() => [
                      _createVNode(SimpImageUpload, {
                        modelValue: fileList.value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((fileList).value = $event)),
                        "is-show-title": false
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _hoisted_10,
                  _createVNode(_component_van_cell, null, {
                    title: _withCtx(() => [
                      _hoisted_11
                    ]),
                    label: _withCtx(() => [
                      (!showFile.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_component_van_uploader, {
                              "after-read": afterRead,
                              accept: "*"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_button, {
                                  icon: "plus",
                                  type: "primary",
                                  block: "",
                                  plain: ""
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_13
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  (_unref(state).suffixName == 'pdf' || _unref(state).suffixName == 'pptx' || _unref(state).suffixName == 'ppt')
                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                        key: 0,
                                        width: "40",
                                        height: "40",
                                        fit: "contain",
                                        src: require('@/assets/project/pdf.png')
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true),
                                  (_unref(state).suffixName == 'docx' || _unref(state).suffixName == 'doc')
                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                        key: 1,
                                        width: "40",
                                        height: "40",
                                        fit: "contain",
                                        src: require('@/assets/project/word.png')
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true),
                                  (_unref(state).suffixName == 'xlsx' || _unref(state).suffixName == 'xls')
                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                        key: 2,
                                        width: "40",
                                        height: "40",
                                        fit: "contain",
                                        src: require('@/assets/project/excel.png')
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true),
                                  (
                            _unref(state).suffixName == 'jpeg' ||
                            _unref(state).suffixName == 'gif' ||
                            _unref(state).suffixName == 'png' ||
                            _unref(state).suffixName == 'jpg'
                          )
                                    ? (_openBlock(), _createBlock(_component_van_image, {
                                        key: 3,
                                        width: "40",
                                        height: "40",
                                        fit: "contain",
                                        src: require('@/assets/project/pisc.png')
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(state).suffixName), 1),
                                  _createElementVNode("div", _hoisted_20, _toDisplayString(conterData.value.size), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_van_icon, {
                                  onClick: to_clear,
                                  name: "clear"
                                })
                              ])
                            ])
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_22,
          _createVNode(_component_common_info, { StaffInfo: StaffInfo.value }, null, 8, ["StaffInfo"]),
          _hoisted_23,
          _createVNode(_component_review_people, { review_carbon: review_carbon.value }, null, 8, ["review_carbon"]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_bottom_button, {
              round: "",
              block: "",
              type: "primary",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_van_popup, {
      show: showTimePicker1.value,
      "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => ((showTimePicker1).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          modelValue: currentDate.value,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((currentDate).value = $event)),
          type: "date",
          title: "选择日期",
          onConfirm: onTimeConfirm1,
          onCancel: _cache[13] || (_cache[13] = ($event: any) => (showTimePicker1.value = false))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: showTimePicker2.value,
      "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => ((showTimePicker2).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          modelValue: currentDate.value,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((currentDate).value = $event)),
          type: "date",
          title: "选择日期",
          onConfirm: onTimeConfirm2,
          onCancel: _cache[16] || (_cache[16] = ($event: any) => (showTimePicker2.value = false))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})